import { Link, useNavigate } from 'react-router-dom'
import Header from '../../components/Header'
import Page from '../../components/Page'
import SerieForm from '../../components/SerieForm'
import { useCreateSerie } from '../../hooks/serie'

export default function SerieCreate() {
  const createSerie = useCreateSerie()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/series">Serie</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Aggiungi
            </li>
          </ol>
        </nav>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <SerieForm
          save={async (serie) => {
            const savedSerie = await createSerie.mutateAsync(serie)
            navigate(`/series/${savedSerie.id}`)
          }}
        />
      </div>
    </Page>
  )
}
